import { render, staticRenderFns } from "./user-header.vue?vue&type=template&id=7d1ae0ba&scoped=true&"
import script from "./user-header.vue?vue&type=script&lang=js&"
export * from "./user-header.vue?vue&type=script&lang=js&"
import style0 from "./user-header.vue?vue&type=style&index=0&id=7d1ae0ba&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d1ae0ba",
  null
  
)

export default component.exports